import { z } from "zod";

const formSchema = z.object({
  shouldSendInvestorLimitDateReachedEmail: z
    .boolean()
    .optional()
    .default(false),
  shouldDisplayNotFilledReporting: z.boolean().optional().default(false),
});
type AutoPublishFormValues = z.infer<typeof formSchema>;

const defaultAutoPublishFormValues: AutoPublishFormValues = {
  shouldSendInvestorLimitDateReachedEmail: false,
  shouldDisplayNotFilledReporting: false,
};

export { formSchema, defaultAutoPublishFormValues, type AutoPublishFormValues };
